import React, { useContext, useEffect, useRef, useState } from 'react';
import FadeIn from 'react-fade-in';
import { Observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import { DropdownList } from 'react-widgets'
import { GlobalHotKeys } from 'react-hotkeys';

import BodyEnd from '../../_shared/BodyEnd';
import ConfirmModal from '../../_shared/ConfirmModalComponent';
import { quickDrawerFocus, renderQuickDrawerLoading } from '../../_shared/QuickDrawer';
import QuickDrawerHeader from '../../_shared/QuickDrawerHeader';

import InventorySearchStore from '../../../../stores/InventorySearchStore';
import QuickDrawerStore from '../../../../stores/QuickDrawerStore';

import * as ErrorMessages from '../../../../constants/errorMessages';
import * as fn from '../../../../utilities/_functions';
import * as oh from '../../../../utilities/operationHelper';

import './MoveMergeProductBrand.scss';

function MoveMergeProductBrand(props) {
    const isMounted = useRef(true);
    const validateRef = useRef(null);
    const confirmModalRef = useRef(null);
    const search = useContext(InventorySearchStore);
    const quickDrawer = useContext(QuickDrawerStore);
    const [toProductBrand, setToProductBrand] = useState(null);
    const [productIds, setProductIds] = useState([]);

    useEffect(() => {
        setToProductBrand(toJS(search.selectedBrand));

        if (props.extraProps && props.extraProps.productIds && props.extraProps.productIds.length > 0) {
            setProductIds(toJS(props.extraProps.productIds));
        }

        quickDrawerFocus(props.drawer);

        return () => {
            isMounted.current = false;
        }
    }, []) // eslint-disable-line

    const handleCancel = () => {
        if (fn.isFunction(props.onCancel)) {
            if (search.hasUnsavedChanges) {
                if (window.confirm(ErrorMessages.DISCARD_CHANGES)) {
                    props.onCancel();
                }
            } else {
                props.onCancel();
            }
        }
    }

    const handleBrandChange = (data) => {
        setToProductBrand(toJS(data));
    }

    const handleSubmit = event => {
        event.preventDefault();

        if (fn.validateForm(validateRef.current)) {
            const message = productIds && productIds.length > 0 ?
                <>Continue to move&nbsp;<span className='tt-underline'>{productIds.length} product(s)</span>&nbsp;to&nbsp;<span className='fw-500'>{toProductBrand ? toProductBrand.name : ''}</span>?</> :
                <>Continue to merge&nbsp;<span className='fw-500'>{search.selectedBrand ? search.selectedBrand.name : ''}</span>&nbsp;into&nbsp;<span className='fw-500'>{toProductBrand ? toProductBrand.name : ''}</span>?</>;

            confirmModalRef.current.show({
                icon: <i className='fal fa-box text-warning-800 mr-2'></i>,
                message: message,
                option1ClassName: 'btn bg-warning-800 bg-warning-700-hover text-white shadow-0 bootbox-accept',
                option1Text: 'Continue',
                cancelText: 'Cancel',
                onOption1Click: handleMoveMergeProductBrandConfirm,
                onCancel: handleMoveMergeProductBrandCancel
            })
        }
    }

    const handleMoveMergeProductBrandConfirm = (event) => {
        (productIds && productIds.length > 0 ?
            search.moveProducts(toProductBrand.id, productIds) :
            search.mergeBrand(toProductBrand.id)
        )
            .then(() => {
                if (isMounted.current) {
                    confirmModalRef.current.close();

                    if (fn.isFunction(props.onSuccess)) {
                        props.onSuccess();
                    }
                }
            })
    }

    const handleMoveMergeProductBrandCancel = (event) => {
        confirmModalRef.current.close();
    }

    return <>
        <Observer>{() =>
            <>
                {
                    (props.drawer === quickDrawer.drawerOpened) ?
                        <GlobalHotKeys
                            keyMap={{
                                close: ['esc'],
                            }}
                            handlers={{
                                close: event => {
                                    handleCancel(event)
                                },
                            }}
                            allowChanges={true}
                        /> : null
                }
            </>
        }</Observer>
        <form ref={validateRef} onSubmit={handleSubmit}>
            <fieldset disabled={search.isSaving}>
                <div className='quick-drawer'>
                    <QuickDrawerHeader
                        drawer={props.drawer}
                        icon={oh.getIcon('product', 'update')}
                        action={productIds && productIds.length > 0 ? 'Move' : 'Merge'}
                        category={productIds && productIds.length > 0 ? 'Products' : 'Product Brand'}
                        className='products'
                        onCancel={handleCancel}
                    />
                    <div className='quick-drawer-body'>
                        <Observer>{() =>
                            search.isReady && toProductBrand ?
                                <FadeIn>
                                    <div className='move-merge-product-brand body-content'>
                                        <Observer>{() =>
                                            <section className='brand'>
                                                <div className='row'>
                                                    <div className='col-12'>
                                                        {
                                                            search.isReady ?
                                                                <div className='form-group mb-0 validate validate-required'>
                                                                    <label className='required'><small>Brand</small></label>
                                                                    <DropdownList
                                                                        data={search.selectedSelector.brands}
                                                                        valueField='id'
                                                                        value={toProductBrand ? toProductBrand.id : ''}
                                                                        itemComponent={({ item }) => (
                                                                            item ? <>
                                                                                {item.name}
                                                                                {
                                                                                    item.supplier ?
                                                                                        <>
                                                                                            <br /><small>{item.supplier.name}</small>
                                                                                        </> : null
                                                                                }
                                                                            </> : <></>
                                                                        )}
                                                                        valueComponent={({ item }) => (
                                                                            item ? <>
                                                                                {item.name}
                                                                                {
                                                                                    item.supplier ?
                                                                                        <>
                                                                                            <small className='text-gray-700 ml-1'>({item.supplier.name})</small>
                                                                                        </> : null
                                                                                }
                                                                            </> : <></>
                                                                        )}
                                                                        onChange={handleBrandChange}
                                                                    />
                                                                </div> : null
                                                        }
                                                    </div>
                                                </div>
                                            </section>
                                        }</Observer>
                                    </div>
                                </FadeIn> : renderQuickDrawerLoading()
                        }</Observer>
                    </div>
                    <div className='quick-drawer-action'>
                        <div className='row'>
                            <div className='col-12'>
                                <div className='float-right'>
                                    <button
                                        type='button'
                                        className='btn btn-link btn-cancel mr-2'
                                        onClick={handleCancel}
                                    >Cancel</button>
                                    <button
                                        type='submit'
                                        className='btn btn-success'
                                    >Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </form>
        <BodyEnd>
            <ConfirmModal ref={confirmModalRef} />
        </BodyEnd>
    </>
}

export default MoveMergeProductBrand;